'use strict';

// Global variable declaration
let portfolio_companies_copy = [];

/**
 * The function `get_portfolio_items` fetches portfolio items from a WordPress API and returns an array
 * of objects containing information about each portfolio item.
 * @returns The function `get_portfolio_items` returns an array of portfolio companies. Each portfolio
 * company object in the array contains properties such as title, slug, link, published_date_gmt,
 * excerpt, investment_status, logo, logo_width, and logo_height.
**/
async function get_portfolio_items() {
  const req_uri = 'https://www.stonegoff.com/wp-json/wp/v2/portfolio/';
  let total_items = 0;
  let total_pages = 0;
  let portfolio_companies = [];

  // First normally fetch the portfolio items as we do not know the total number of items and how many times we need to send requests
  try {
    let server_response = await fetch(`${req_uri}?page=1&per_page=10&_embed=true`);

    if (server_response?.ok) {
      total_items = parseInt( server_response?.headers?.get('X-Wp-Total') );
      total_pages = parseInt( server_response?.headers?.get('X-Wp-Totalpages') );

      let response_data = await server_response?.json();

      // Loop through the remaining pages to fetch all the contents
      for ( let i = 2; i <= total_pages; i++ ) {
        server_response = await fetch(`${req_uri}?page=${i}&per_page=10&_embed=true`);

        if ( server_response?.ok ) {
          let response_data_loop = await server_response?.json();

          // Add the fetched content to the response_data variable
          response_data = [
            ...response_data,
            ...response_data_loop
          ];
        } else {
          // if the response is not OK, throw a new error with the error code
          throw new Error(`The network is returning ERROR: ${server_response.status}`);
        }
      }

      // Store the received data
      response_data.forEach( (item) => {
        portfolio_companies = [
          ...portfolio_companies,
          {
            title: item.title.rendered,
            slug: item.slug,
            link: item.link,
            published_date_gmt: item.date_gmt,
            investment_status: item?.acf?.investment_status,
            logo: item._embedded['wp:featuredmedia'][0].source_url,
            logo_width: item?.acf?.image_width_showcase_webpages,
            logo_height: item?.acf?.image_height_showcase_webpages
          }
        ];
      } );
    } else {
      // if the response is not OK, throw a new error with the error code
      throw new Error(`The network is returning ERROR: ${server_response.status}`);
    }
  } catch (err) {
    throw new Error(`Error: ${err.message}`);
  }

  return portfolio_companies;
}

/**
 * The function `show_portfolio_companies` is an asynchronous function that handles the display of
 * portfolio companies based on user input and filters.
 * @param event - The `event` parameter is an object that represents the event that triggered the
 * function. It is typically an event object that is passed to an event handler function. In this case,
 * the function `show_portfolio_companies` is an asynchronous function that is intended to be used as
 * an event handler for an
**/
async function show_portfolio_companies(event) {
  event.preventDefault();

  // Declare the variables that will be used below
  let portfolio_companies = [];
  let portfolio_companies_html = '';

  const portfolio_search_form = document.getElementById('portfolio-search-form');
  const portfolio_company_holder = document.querySelector('div.searchable-portfolio-company-logos');
  
  // console.log(event.type)

  if (event.type === 'click') {
    portfolio_search_form.reset();
  }

  const form_data = new FormData(portfolio_search_form);

  const search_text = form_data.get('portfolio-name-search');
  const item_sort = form_data.get('portfolio-item-sort');
  const investment_status = form_data.get('portfolio-investment-status');

  // console.log(search_text, item_sort, investment_status);

  if (portfolio_companies_copy.length === 0) {
    portfolio_companies = await get_portfolio_items();
    portfolio_companies_copy = [...portfolio_companies];
  } else {
    portfolio_companies = [...portfolio_companies_copy];
  }

  // Sort the item based on the selected option
  switch (item_sort) {
    case 'a-z':
      portfolio_companies = [...portfolio_companies_copy].sort( (a, b) => a.title.localeCompare(b.title) );
    break;

    case 'z-a':
      portfolio_companies = [...portfolio_companies_copy].sort( (a, b) => b.title.localeCompare(a.title) );
    break;

    case 'newest-first':
      portfolio_companies = [...portfolio_companies_copy].sort((a, b) => new Date(b.published_date_gmt) - new Date(a.published_date_gmt));
    break;

    case 'oldest-first':
      portfolio_companies = [...portfolio_companies_copy].sort((a, b) => new Date(a.published_date_gmt) - new Date(b.published_date_gmt));
    break;
  }

  // Filter the portfolio_companies based on investment status
  switch (investment_status) {
    case 'current':
      portfolio_companies = portfolio_companies.filter( (company) => company.investment_status === 'current-holding' )
    break;
    
    case 'exited':
      portfolio_companies = portfolio_companies.filter( (company) => company.investment_status === 'exited' )
    break;
  }

  // Filter the portfolio companies based on the search test
  if ( search_text?.length > 0 ) {
    portfolio_companies = portfolio_companies.filter( (company) => company.title.toLowerCase().includes( search_text.toLowerCase() ) );
  }

  // Loop through the portfolio_companies to generate the final HTML
  portfolio_companies.forEach( (company) => {
    portfolio_companies_html += `<article class="portfolio-company-details d-flex justify-content-center align-items-center p-3">
      <a href="${company.link}" class="portfolio-company-page-link d-block" aria-labelledby="${company.slug}-company-name">
        <figure class="portfolio-company-logo-holder mb-0">
          <img width="${company.logo_width}" height="${company.logo_height}" loading="eager" decoding="async" src="${company.logo}" class="portfolio-company-logo img-fluid align-self-center px-2" alt="${company.title} Logo">
        </figure>
        <span id="${company.slug}-company-name" class="visually-hidden">${company.title}</span>
      </a>
    </article>`;
  } );

  // Show the portfolio companies
  portfolio_company_holder.innerHTML = portfolio_companies_html;

  // console.log(portfolio_companies);
}

// Execute the code on page load
document.addEventListener('DOMContentLoaded', show_portfolio_companies);

// Execute the code on form item change
document.getElementById('portfolio-name-search').addEventListener('input', show_portfolio_companies);
document.getElementById('portfolio-item-sort').addEventListener('change', show_portfolio_companies);
document.getElementById('portfolio-investment-status').addEventListener('change', show_portfolio_companies);
document.getElementById('portfolio-search-form-reset').addEventListener('click', show_portfolio_companies);